const primeHooverBannerBgImages = {
  ED: "/images/ED/PrimeNotLogged/background-banner-results-page-ED.svg",
  OP: "/images/OP/PrimeNotLogged/background-banner-results-page.svg",
  GO: "/images/GO/PrimeNotLogged/background-banner-results-page.svg",
};

const primeHooverBannerColors = {
  primary90: "primary.90",
  primary70: "primary.70",
  primary50: "primary.50",
  primary30: "primary.30",
  secondary50: "secondary.50",
  neutral0: "neutral.0",
  dark: "linear-gradient(325.45deg, #002C52 8.02%, #002C52 57.39%, #00396B 148.55%)",
};

export const primeHooverBannerBrandConfig = {
  OP: {
    bgColor: primeHooverBannerColors.primary90,
    bgImage: primeHooverBannerBgImages.OP,
    textColor: primeHooverBannerColors.neutral0,
    titleColor: primeHooverBannerColors.primary50,
    headerBgColor: primeHooverBannerColors.primary90,
  },
  ED: {
    bgColor: primeHooverBannerColors.primary90,
    bgImage: primeHooverBannerBgImages.ED,
    textColor: primeHooverBannerColors.neutral0,
    titleColor: primeHooverBannerColors.secondary50,
    headerBgColor: primeHooverBannerColors.dark,
  },
  GO: {
    bgColor: primeHooverBannerColors.primary90,
    bgImage: primeHooverBannerBgImages.GO,
    textColor: primeHooverBannerColors.neutral0,
    titleColor: primeHooverBannerColors.primary30,
    headerBgColor: primeHooverBannerColors.primary70,
  },
};
